import { getColor } from './openingTimeHelpers'
import Chart from 'react-apexcharts'
import React from 'react'
import { useTranslation } from 'react-i18next'

const OpenRateRadialChart = React.memo(({ rate, animationsEnabled, ...props }) => {
    const [t] = useTranslation()

    return (
      <div className={props.className}>
          <Chart
            options={{
                chart: {
                    type: 'radialBar',
                    animations: {
                        enabled: animationsEnabled ?? false,
                        dynamicAnimation: {enabled: false}
                    },
                },
                colors: [getColor(rate)],
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            strokeWidth: '97%',
                        },
                        hollow: {
                            size: '80%',
                        },
                        dataLabels: {
                            name: {
                                show: true,
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#333',
                                offsetY: 15,
                            },
                            value: {
                                fontSize: '26px',
                                color: getColor(rate),
                                offsetY: -30,
                                formatter: function (val) {
                                    return val + '%'
                                },
                            },
                        },
                    },
                },
                labels: [t('openings.opening_times.average_opening')],
            }}
            series={[rate]}
            type="radialBar"
            height={200}
          />
      </div>
    )
})

export { OpenRateRadialChart }
